import { render } from "./WhoAlphaLabs00.vue?vue&type=template&id=7c014203&scoped=true"
import script from "./WhoAlphaLabs00.vue?vue&type=script&lang=js"
export * from "./WhoAlphaLabs00.vue?vue&type=script&lang=js"

import "./WhoAlphaLabs00.vue?vue&type=style&index=0&id=7c014203&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c014203"]])

export default __exports__